export default __webpack_public_path__ + "static/media/forgot-password.f0568d74.png";